import { Component, OnInit } from '@angular/core';
import { CoreService } from '../../../../service/core.service';

@Component({
  selector: 'app-branch-transfer-receipt',
  templateUrl: './branch-transfer-receipt.component.html',
  styleUrls: ['./branch-transfer-receipt.component.css']
})
export class BranchTransferReceiptComponent implements OnInit {
  up: any;

  constructor(private coreService: CoreService) { }

  ngOnInit() {
    this.up = this.coreService.getUserPrivilage();

  }

}
